import { Input } from '@/components/ui/input';
import {
  SURVEY_ANSWER_TYPE_LABELS,
  SURVEY_TEXT_PLACEHOLDER_BY_ANSWER_TYPE,
} from '../../constants/survey.constants';
import type { SurveyQuestionDetail } from '../../types/survey.types';

interface SurveyTextPreviewProps {
  question: SurveyQuestionDetail;
}

export function SurveyTextPreview({ question }: SurveyTextPreviewProps) {
  const placeholder = question.answerType
    ? SURVEY_TEXT_PLACEHOLDER_BY_ANSWER_TYPE[question.answerType]
    : 'User will enter their answer';

  const isNumericAnswer = question.answerType !== null && question.answerType !== 'text';
  const hasMin = isNumericAnswer && question.minValue !== null;
  const hasMax = isNumericAnswer && question.maxValue !== null;

  return (
    <div className="space-y-2">
      <Input disabled placeholder={placeholder} className="h-10" />
      <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
        {question.answerType ? (
          <span>
            <span className="font-medium text-foreground">Type:</span>{' '}
            {SURVEY_ANSWER_TYPE_LABELS[question.answerType]}
          </span>
        ) : null}
        {hasMin && hasMax ? (
          <span>
            <span className="font-medium text-foreground">Range:</span> {question.minValue} to{' '}
            {question.maxValue}
          </span>
        ) : hasMin ? (
          <span>
            <span className="font-medium text-foreground">Min:</span> {question.minValue}
          </span>
        ) : hasMax ? (
          <span>
            <span className="font-medium text-foreground">Max:</span> {question.maxValue}
          </span>
        ) : null}
        {question.maxChars !== null ? (
          <span>
            <span className="font-medium text-foreground">Max:</span> {question.maxChars} characters
          </span>
        ) : null}
      </div>
    </div>
  );
}
